
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Banertomumbaicab() {



    const cardData =
    {
        keyword: 'Baner to Mumbai Cabs',
        heading: 'Meghana Cab : Baner to Mumbai Cabs',
        headingDescription: 'Meghana Cab offers Baner to Mumbai Cabs, providing a seamless and comfortable travel experience from one of Pune’s prime localities to the heart of Mumbai. Whether it’s a business trip, airport transfer, or a leisure visit, our cab services ensure timely pickups from Baner and smooth rides to your Mumbai destination. Choose from a wide range of vehicles including Sedans, SUVs, Innova Crysta, and Tempo Travellers to match your group size and comfort preferences. With transparent pricing, experienced drivers, and 24/7 support, book your Baner to Mumbai Cab with Meghana Cab for safe, convenient, and stress-free travel.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [
   
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

"services": [
    {
        "name": "Baner to Mumbai Cab Booking",
        "description": "Book a reliable cab from Baner to Mumbai with ease. Our service offers a range of vehicles, punctual drivers, and flexible scheduling for seamless intercity travel. Ideal for business, leisure, and airport transfers, ensuring a comfortable journey every time."
    },
    {
        "name": "Online Taxi Baner to Mumbai",
        "description": "Conveniently book your Baner to Mumbai taxi online through our secure platform. Choose from sedans, SUVs, and more with instant confirmation and transparent pricing, perfect for hassle-free travel planning."
    },
    {
        "name": "One Way Cab Baner to Mumbai",
        "description": "Travel one way from Baner to Mumbai without worrying about return fares. Our one way cab service provides cost-effective, comfortable rides for airport drops, meetings, or family visits."
    },
    {
        "name": "Round Trip Baner to Mumbai Cab",
        "description": "Plan your return journey with our round trip cab service from Baner to Mumbai. Benefit from discounted rates, driver waiting options, and flexible timings suited for business trips and day tours."
    },
    {
        "name": "AC Cab Hire Baner to Mumbai",
        "description": "Stay cool and comfortable during your trip from Baner to Mumbai with our air-conditioned cab service. Perfect for long-distance travel in all weather conditions, ensuring a relaxing and pleasant ride."
    },
    {
        "name": "Budget Cab Baner to Mumbai",
        "description": "Get affordable and reliable cab service from Baner to Mumbai without compromising on quality. Our budget cabs are well-maintained and driven by professional chauffeurs, ideal for daily commuters and families."
    },
    {
        "name": "Sedan Taxi Baner to Mumbai",
        "description": "Opt for our sedan taxis for an efficient and stylish journey from Baner to Mumbai. Perfect for solo travelers and couples looking for comfort, space, and smooth rides at competitive prices."
    },
    {
        "name": "SUV Cab Baner to Mumbai",
        "description": "Need extra space? Our SUV cabs from Baner to Mumbai provide ample seating and luggage room, making them perfect for families, group travel, or anyone wanting a spacious and safe ride."
    },
    {
        "name": "Fast Cab from Baner to Mumbai",
        "description": "Book our fast cab service from Baner to Mumbai to ensure timely pickups and speedy travel. Ideal for urgent airport transfers, last-minute business meetings, and emergency trips."
    },
    {
        "name": "Baner Pickup Taxi to Mumbai",
        "description": "Enjoy reliable pickup service from anywhere in Baner to Mumbai. Our drivers track your location in real-time and ensure punctual arrival, making your travel smooth and stress-free."
    },
    {
        "name": "Chauffeur Driven Cab Baner to Mumbai",
        "description": "Experience luxury and convenience with our chauffeur-driven cabs from Baner to Mumbai. Our professional drivers provide safe, courteous, and comfortable rides for business executives and VIP travelers."
    },
    {
        "name": "Private Cab Baner to Mumbai",
        "description": "Book a private cab for exclusive use from Baner to Mumbai. Enjoy privacy, direct routes, and personalized service, perfect for family outings, special events, or VIP transfers."
    },
    {
        "name": "24-Hour Taxi Baner to Mumbai",
        "description": "Our 24-hour taxi service from Baner to Mumbai ensures you can travel anytime, day or night. Whether it’s an early morning flight or late-night arrival, we are always ready to serve you."
    },
    {
        "name": "Corporate Travel Baner to Mumbai Cab",
        "description": "Simplify your corporate travel needs with our dedicated Baner to Mumbai cab service. We offer professional vehicles, reliable schedules, and invoicing options suitable for business trips and company events."
    },
    {
        "name": "Family Cabs Baner to Mumbai",
        "description": "Travel safely with your family in our spacious and comfortable family cabs from Baner to Mumbai. Equipped with child safety features and friendly drivers, ensuring a worry-free journey for all ages."
    }
],
"tableData": [
    ["Baner to Mumbai Cab Booking", "Online Taxi Baner to Mumbai"],
    ["One Way Cab Baner to Mumbai", "Round Trip Baner to Mumbai Cab"],
    ["AC Cab Hire Baner to Mumbai", "Budget Cab Baner to Mumbai"],
    ["Sedan Taxi Baner to Mumbai", "SUV Cab Baner to Mumbai"],
    ["Fast Cab from Baner to Mumbai", "Baner Pickup Taxi to Mumbai"],
    ["Chauffeur Driven Cab Baner to Mumbai", "Private Cab Baner to Mumbai"],
    ["24-Hour Taxi Baner to Mumbai", "Corporate Travel Baner to Mumbai Cab"],
    ["Family Cabs Baner to Mumbai", ""]
],







"whychoose": [
    {
        "WhyChooseheading": "Reliable Baner to Mumbai Cab Services",
        "WhyChoosedescription": "Our Baner to Mumbai cab service offers punctual and dependable transportation, ensuring you reach your destination on time whether it's for business meetings, airport transfers, or personal travel."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Travel in clean, air-conditioned cars equipped with comfortable seating and ample luggage space. Our vehicles are regularly serviced and sanitized to provide a safe and pleasant journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our courteous drivers are well-acquainted with the Baner to Mumbai route and committed to providing a smooth, safe ride while adhering to traffic regulations and customer preferences."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We provide clear and competitive pricing for your Baner to Mumbai cab needs. All costs include fuel, tolls, taxes, and driver allowances, with no hidden charges for complete peace of mind."
    },
    {
        "WhyChooseheading": "Flexible Booking Options",
        "WhyChoosedescription": "Book your cab for one-way travel, round trips, or hourly rentals with flexible scheduling. Customize pickup and drop locations to suit your itinerary and enjoy stress-free travel planning."
    },
    {
        "WhyChooseheading": "Door-to-Door Pickup and Drop-off",
        "WhyChoosedescription": "Experience the convenience of our doorstep service. We pick you up from your preferred location in Baner and drop you directly at your destination in Mumbai, ensuring a hassle-free journey."
    },
    {
        "WhyChooseheading": "Ideal for Business, Leisure, and Airport Transfers",
        "WhyChoosedescription": "Whether traveling for work, leisure, or to catch a flight, our Baner to Mumbai cabs offer the comfort, reliability, and professionalism you need for a seamless journey."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Assistance",
        "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, route changes, or any travel-related queries, ensuring you have a smooth and worry-free experience."
    }
]




















    }

const faqData = [
    {
        question: "How can I book a cab from Baner to Mumbai?",
        answer: "You can book a cab easily by calling Meghana Cab at +91 9075462128 or through our website for instant confirmation."
    },
    {
        question: "What is the estimated duration of the trip from Baner to Mumbai?",
        answer: "The journey usually takes about 3 to 4 hours, depending on traffic and weather conditions."
    },
    {
        question: "What types of cabs are available for travel from Baner to Mumbai?",
        answer: "We offer a range of vehicles including hatchbacks, sedans, SUVs, and tempo travellers to suit your travel requirements."
    },
    {
        question: "Is the cab service from Baner to Mumbai available 24/7?",
        answer: "Yes, our cab services are available round the clock to fit your travel schedule."
    },
    {
        question: "Are there one way and round trip options available?",
        answer: "Yes, both one way and round trip services are available for Baner to Mumbai routes."
    },
    {
        question: "Is the fare from Baner to Mumbai fixed or does it vary?",
        answer: "We offer competitive and transparent pricing. The fare may vary slightly based on car type, time of travel, and route conditions."
    },
    {
        question: "What is included in the Baner to Mumbai cab fare?",
        answer: "The fare includes fuel, tolls, and driver charges. Waiting or additional stops may incur extra charges."
    },
    {
        question: "Can I make a stopover during the trip?",
        answer: "Yes, short stops can be accommodated. Please let us know in advance when booking the cab."
    },
    {
        question: "Is online booking available for Baner to Mumbai cabs?",
        answer: "Yes, you can conveniently book online through our website 24/7."
    },
    {
        question: "Are your drivers professional and familiar with the Baner-Mumbai route?",
        answer: "Yes, all our drivers are experienced, courteous, and knowledgeable about the Baner to Mumbai route."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Ramesh Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked a cab from Baner to Mumbai for my flight. The service was punctual, and the ride was extremely comfortable.”',
    },
    {
        name: 'Ms. Pooja Bapat',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I use Meghana Cab regularly for travel from Baner to Mumbai. Always reliable, clean cars, and friendly drivers.”',
    },
];



















































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Baner to Mumbai Cabs",
  "image": "https://www.meghanacabs.com/assets/images/baner-to-mumbai-cabs.jpg",
  "description": "Book comfortable and reliable cabs from Baner to Mumbai with Meghana Cabs. Choose from AC Sedans, SUVs, and chauffeur-driven cars. Affordable one-way and round trip options with 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1799",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/baner-to-mumbai-cabs"
  }
};






    return (
        <div>

<Helmet>
  <title>Baner to Mumbai Cabs | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book a cab from Baner to Mumbai online with Meghana Cabs. Affordable fares, AC Sedan and SUV options, 24/7 service, and chauffeur-driven rides. Available for one-way and round trip travel." 
  />
  <meta 
    name="keywords" 
    content="Baner to Mumbai Cab Booking, Online Taxi Baner to Mumbai, One Way Cab Baner to Mumbai, Round Trip Baner to Mumbai Cab, AC Cab Hire Baner to Mumbai, Budget Cab Baner to Mumbai, Sedan Taxi Baner to Mumbai, SUV Cab Baner to Mumbai, Fast Cab from Baner to Mumbai, Baner Pickup Taxi to Mumbai, Chauffeur Driven Cab Baner to Mumbai, Private Cab Baner to Mumbai, 24-Hour Taxi Baner to Mumbai, Corporate Travel Baner to Mumbai Cab, Family Cabs Baner to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/74.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Banertomumbaicab;